import React from "react";
import { useSelector } from "react-redux";
import { stackedBarPairedPalette } from "../colors";
import D3StackedBar from "./D3StackedBar";
import RccCard from "../RccCard";
import { usePipelineCreatedMixTeamData } from "../hooks/usePipelineCreatedMixData";

/**
 * PipelineCreatedByTeamRaid9Card.jsx
 *
 * Displays Pipeline Created Mix by Team filtered for Raid 9 product.
 * Uses the shared pipeline created mix hook with Products_Of_Interest filter
 * and month-based timeframe override (first 4 months).
 *
 */
function PipelineCreatedByTeamRaid9Card({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app.user || {});
  const Value_Label = useSelector((state) => state.app.user.Value_Label);
  const { chartData, derivedCategories, appliedFilters, isLoading } =
    usePipelineCreatedMixTeamData([
      { name: "Products_Of_Interest", value: ["RAID 9"], string: true },
      { name: "Open_Date_Initial_Fiscal_Quarter", count: 0 }, // Skip default quarter filter
      { name: "Open_Initial_Year_Month", count: 4 }, // Get first 4 months
    ]);

  const handleZoom = () => {
    console.log("Zooming card...");
  };

  return (
    <RccCard
      title={title || "Pipeline Created by Team - Raid 9"}
      isLoading={isLoading}
      redirectToDashboard={
        redirectToDashboard || "Pipeline Created Mix Analysis"
      }
      onZoomClick={handleZoom}
      appliedFilters={appliedFilters}
      excludeFilters={["team", "acv", "Open_Initial_Year_Month"]}
      focusVariant={"future"}
    >
      <D3StackedBar
        data={chartData}
        categories={derivedCategories}
        colorPalette={stackedBarPairedPalette}
        currencySymbol={user?.Currency}
        options={{
          showLabels: true,
          showLegend: true,
        }}
      />
    </RccCard>
  );
}

export default PipelineCreatedByTeamRaid9Card;
